import Domain from './name';
import reducer from './reducer';
import Actions from './actions';
import * as selectors from './selectors';
import { reducerRegistry } from 'store';

reducerRegistry.register(Domain, reducer);

// public api
export { Actions, selectors };
